import { CircleX, Plus } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import PlusSvg from "./svgr/Plus";
import { useSearchParams } from "react-router-dom";

const statusList = ["Processing", "Completed", "Failed"];

function FilterModal() {
  const [searchParams, setSearchParams] = useSearchParams();
  const statusFromURL = searchParams.get("status") || "";

  const [filterStatus, setFilterStatus] = useState<string>(statusFromURL);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleCloseDropdown = () => {
    setShowDropdown(false);
  };

  const handleApplyFilter = () => {
    if (filterStatus) {
      searchParams.set("status", filterStatus);
    } else {
      searchParams.delete("status");
    }
    setSearchParams(searchParams);
    setShowDropdown(false);
  };

  const handleReset = () => {
    setFilterStatus("");
  };

  const handleResetAll = () => {
    searchParams.delete("status");
    setSearchParams(searchParams);
    setFilterStatus("");
  };

  useEffect(() => {
    setFilterStatus(statusFromURL); // preload from URL if user refreshes
  }, [statusFromURL]);

  return (
    <Dropdown
      show={showDropdown}
      onToggle={(isOpen) => setShowDropdown(isOpen)}
      className="d-inline"
    >
      <Dropdown.Toggle
        id="dropdown-autoclose-true"
        className={showDropdown ? "filter-toggle-btn" : ""}
        variant=""
      >
        {showDropdown ? <PlusSvg className="mr-1" /> : <Plus className="mr-1" size={16} />}
        Add Filter
      </Dropdown.Toggle>

      <Dropdown.Menu className="filter-tray">
        <div className="filter-top">
          <span>Filter By</span>
          <CircleX onClick={handleCloseDropdown} style={{ cursor: "pointer" }} />
        </div>

        <div className="filter-mid">
          <div>
            <label htmlFor="">Status</label>
            <button disabled={!filterStatus} onClick={handleReset}>
              Reset
            </button>
          </div>
          <Form>
            <Form.Group className="form-group-custom" controlId="custom-select">
              <Form.Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                aria-label="Default select example"
                className="form-select-custom"
              >
                <option value="">Select one</option>
                {statusList.map((stats) => (
                  <option key={stats} value={stats}>
                    {stats}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </div>

        <div className="filter-bottom">
          <Button variant="" onClick={handleResetAll} id={`${statusFromURL ? "reset-btn" : ""}`}>
            Reset all Filter
          </Button>
          <Button
            variant=""
            className="active-btn"
            disabled={!filterStatus}
            onClick={handleApplyFilter}
          >
            Apply Filter
          </Button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}


export default FilterModal;
